import { isResource } from '@medplum/core'
import type { Encounter, Patient, Reference } from '@medplum/fhirtypes'
import {
  ExtendedEncounter,
  type ExtendedEncounterArgs,
} from '#src/models/encounters/encounter.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export class NonVisitEncounter extends ExtendedEncounter {
  constructor({
    status,
    ...args
  }: Omit<ExtendedEncounterArgs, 'class' | 'status'> & {
    status?: Encounter['status']
  }) {
    super({
      ...args,
      class: 'NON_VISIT',
      status: status ?? 'in-progress',
    })
  }

  static readonly BASE_SEARCH_QUERY: QueryTypes = {
    ...ExtendedEncounter.BASE_QUERY_STRUCTURE,
    class: ExtendedEncounter.ENCOUNTER_CLASS.NON_VISIT,
  }

  static searchByPatient(patient: Reference<Patient>): QueryTypes {
    return {
      ...this.BASE_SEARCH_QUERY,
      subject: patient,
    }
  }

  static byPatientInProgress(patient: Reference<Patient>): QueryTypes {
    return {
      ...this.BASE_SEARCH_QUERY,
      subject: patient,
      status: 'in-progress',
    }
  }

  static isInstance(value: unknown): value is Encounter {
    return (
      isResource(value) &&
      isOfType(value, 'Encounter') &&
      value.class.code === ExtendedEncounter.ENCOUNTER_CLASS.NON_VISIT.code
    )
  }
}
